function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAlertAvatari = function SvgAlertAvatari(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M11.999 15.201a1.4 1.4 0 0 1 .778.236c.23.154.409.373.515.628a1.4 1.4 0 0 1-.303 1.525 1.4 1.4 0 0 1-.717.383 1.4 1.4 0 0 1-.808-.079 1.4 1.4 0 0 1-.864-1.293 1.396 1.396 0 0 1 1.398-1.395zM10.6 7.395v5.067a1.4 1.4 0 0 0 1.399 1.4 1.4 1.4 0 0 0 1.4-1.4V7.399A1.4 1.4 0 0 0 11.999 6 1.401 1.401 0 0 0 10.6 7.399z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAlertAvatari);
export default ForwardRef;